import $ from 'jquery'

export default {
	name: 'importer-medicament',
	components: {},
	props: {
		type_article: String
	},
	data() {
		return {
			files: [],
			is_loading: false,
			is_error: false,
			msg_error: '',

			// Import par lots (15/10/2026) : avancement affiché en pourcentage
			import_id: null,
			taille_lot: 0,
			import_en_cours: false,
			annulation_demandee: false,
			// Ligne à partir de laquelle reprendre après une erreur de lot (null = pas d'erreur)
			reprise_ligne: null,
			avancement: {
				pourcentage: 0,
				lignes_traitees: 0,
				total_lignes: 0
			}
		}
	},
	computed: {
		libelle_articles() {
			return (this.type_article == '1') ? 'médicaments' : 'consommables'
		}
	},
	mounted() {

	},
	methods: {
		handleFilesUpload() {
			$('.err-msg').fadeOut()
			let uploadedFiles = this.$refs.files.files;
			/*
			  Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}
		},


		importMedicament() {
			// Un seul import à la fois
			if (this.import_en_cours) {
				return
			}
			this.is_loading = true

			let formData = new FormData();
			$('.err-msg').fadeOut()
			this.is_error = false
			this.msg_error = ''

			let err = 0

			if (this.files.length == 0) {
				err++
			}

			if (err == 0) {
				// Import abandonné après une interruption : le fichier déposé est supprimé côté serveur
				if (this.import_id && this.reprise_ligne !== null) {
					this.$store.dispatch('annulerImportArticles', { import_id: this.import_id }).catch(() => {})
				}

				formData.append('file', this.files[0]);
				formData.append('type_article', this.type_article);

				// Autorisation de notification demandée au clic, pour prévenir à la fin d'un long import
				this.demanderAutorisationNotification()

				// Dépôt du fichier, puis traitement lot par lot (aucune requête ne dépasse le max_execution_time)
				this.$store.dispatch('demarrerImportArticles', { 'data': formData }).then((avancement) => {
					this.import_id = avancement.import_id
					this.taille_lot = avancement.taille_lot
					this.import_en_cours = true
					this.annulation_demandee = false
					this.majAvancement(avancement)
					this.traiterLots(avancement)
				}).catch((error) => {
					this.is_error = true
					this.is_loading = false
					this.msg_error = (error && error.response && error.response.status == 422)
						? "Le fichier n'est pas accepté. Vérifiez qu'il s'agit d'un fichier Excel (.xlsx, .xls, .csv)."
						: "Une erreur s'est produite lors de l'envoi du fichier. Merci de réessayer plus tard."
				})
			} else {
				// Afficher un message informant l'utilisateur de choisir un fichier
				$('.err-msg').fadeIn(500)
				this.is_loading = false
			}
		},

		/**
		 * Enchaîne les lots jusqu'à la fin. Un lot en échec est relancé deux fois (coupure réseau passagère) ; ensuite
		 * l'import s'arrête et peut être repris depuis la même ligne (un lot est enregistré entièrement ou pas du tout).
		 */
		async traiterLots(avancement) {
			let courant = avancement
			this.reprise_ligne = null
			this.msg_error = ''

			while (!courant.termine) {
				if (this.annulation_demandee) {
					return
				}

				let essais = 0
				let suivant = null
				while (suivant === null) {
					try {
						suivant = await this.$store.dispatch('importerLotArticles', {
							import_id: this.import_id,
							debut: courant.prochaine_ligne
						})
					} catch (error) {
						essais++
						if (essais > 2 || (error && error.response && error.response.status == 404)) {
							this.arreterSurErreur(courant)
							return
						}
						await new Promise(resolve => setTimeout(resolve, 1500 * essais))
					}
				}

				courant = suivant
				this.majAvancement(courant)
			}

			this.terminerImport(courant)
		},

		majAvancement(avancement) {
			this.avancement = {
				pourcentage: avancement.pourcentage,
				lignes_traitees: avancement.lignes_traitees,
				total_lignes: avancement.total_lignes
			}
		},

		arreterSurErreur(avancement) {
			// Lignes du fichier (les données commencent après la ou les lignes d'en-tête)
			const debut = avancement.prochaine_ligne
			const fin = debut + this.taille_lot - 1

			this.import_en_cours = false
			this.is_loading = false
			this.is_error = true
			this.reprise_ligne = debut
			this.msg_error = "L'import s'est arrêté sur les lignes " + debut + " à " + fin + " du fichier. Les lignes précédentes sont enregistrées. Vous pouvez reprendre l'import à partir de ces lignes."
		},

		reprendreImport() {
			if (this.reprise_ligne === null || !this.import_id) {
				return
			}
			this.is_error = false
			this.is_loading = true
			this.import_en_cours = true
			this.annulation_demandee = false
			this.traiterLots({ termine: false, prochaine_ligne: this.reprise_ligne })
		},

		/**
		 * Arrête l'import en cours : les lots déjà traités restent enregistrés, le fichier déposé est supprimé
		 */
		annulerImport() {
			if (!this.import_id) {
				return
			}
			this.annulation_demandee = true
			this.$store.dispatch('annulerImportArticles', { import_id: this.import_id }).catch(() => {})

			const traitees = this.avancement.lignes_traitees
			this.import_en_cours = false
			this.is_loading = false
			this.reprise_ligne = null
			this.import_id = null
			this.successToast("Import arrêté : " + traitees + " ligne(s) déjà enregistrée(s).")
			this.emettreRafraichissement()
		},

		terminerImport(avancement) {
			this.import_en_cours = false
			this.is_loading = false
			this.import_id = null
			this.files = []
			var preview = document.getElementById('files');
			if (preview) {
				preview.value = "";
			}

			// La fenêtre n'existe plus si l'utilisateur a changé d'écran pendant l'import
			if (this.$refs.close_modal) {
				this.$refs.close_modal.click()
			}

			const message = "Importation des " + this.libelle_articles + " terminée : " + avancement.total_lignes + " ligne(s) traitée(s)."
			this.successToast(message)
			this.notifierFinImport(message)
			this.emettreRafraichissement()
		},

		emettreRafraichissement() {
			if (this.type_article == '1') {
				this.$emit("emitListMedicament")
			} else {
				this.$emit("emitListConsommable")
			}
		},

		demanderAutorisationNotification() {
			if (typeof window === 'undefined' || !('Notification' in window)) {
				return
			}
			if (Notification.permission === 'default') {
				// Anciennes versions : requestPermission ne renvoie pas de promesse
				const demande = Notification.requestPermission()
				if (demande && demande.catch) {
					demande.catch(() => {})
				}
			}
		},

		/**
		 * Notification système (Electron / navigateur) : visible même si l'utilisateur a changé d'écran ou de fenêtre
		 */
		notifierFinImport(message) {
			if (typeof window === 'undefined' || !('Notification' in window) || Notification.permission !== 'granted') {
				return
			}
			try {
				new Notification('Import terminé', { body: message })
			} catch (e) {
				// Notification indisponible : le toast suffit
			}
		},
	}
}
